let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lnCW7")).then(() => parcelRequire('j8dZ5'));